import { render, staticRenderFns } from "./UserPerformance.vue?vue&type=template&id=e517cbf6&scoped=true"
import script from "./UserPerformance.vue?vue&type=script&lang=js"
export * from "./UserPerformance.vue?vue&type=script&lang=js"
import style0 from "./UserPerformance.vue?vue&type=style&index=0&id=e517cbf6&prod&lang=scss&scoped=true"
import style1 from "./UserPerformance.vue?vue&type=style&index=1&id=e517cbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e517cbf6",
  null
  
)

export default component.exports